module.exports = __webpack_public_path__ + "media/application/images/icons/wiki-search-00b8631b84ddb0e9211559c65f73111d.svg";